//state
import axios from "axios";

export var quizState = {
  quizes: [],
  quiz_stat: [],
  quiz_stat_group: [],
  status_quiz: "",
  images: [],
  gallerys: [],
  buttons: [],
  quiz_preview_response: {},
  id_preview: "",
  quizbyPartner: [],
  singlefield: [],
  respustasCount: 0,
  paraCompletar: 0,
  completadosCount: 0,
  commenzadosCount: 0,
  imagebyQuiz: [],
  graphdatabyQuiz: [],
  respustasData: [],
  respustasAnswerData: [],
  overview_stats: [],
  uuids_res: [],
  questions: [],
  question_options: [],
  ques_id: "",
  option_id: "",
  // ANCHOR State
  s_gallerys: [],
  s_gallery_page: [],
  s_getGallerys: [],
  s_getGalleryPages: [],
};

//getters
export var quizGetters = {
  //funciones para optener informacion del state
  getQuizes: (state) => state.quizes,
  getQuizesbyPartner: (state) => state.quizbyPartner,
  getQuizstatFinish: (state) => state.quiz_stat,
  getQuizstatGroupby: (state) => state.quiz_stat_group,
  getquizButtons: (state) => state.buttons,
  getImages: (state) => state.images,
  getGallerys: (state) => state.gallerys,
  getQuizPreviewResponse: (state) => state.quiz_preview_response,
  getIdPreview: (state) => state.id_preview,
  getRespustasCount: (state) => state.respustasCount,
  getparaCompletar: (state) => state.paraCompletar,
  getCompletadosCount: (state) => state.completadosCount,
  getcommenzadosCount: (state) => state.commenzadosCount,
  getImagebyQuiz: (state) => state.imagebyQuiz,
  getGraphdatabyQuiz: (state) => state.graphdatabyQuiz,
  getRespustasData: (state) => state.respustasData,
  getrespustasAnswerData: (state) => state.respustasAnswerData,
  getstatOverview: (state) => state.overview_stats,
  respustasDelete: (state) => state.uuids_res,
  getQuestionDetails: (state) => state.questions,
  getQuestionOptions: (state) => state.question_options,
  getIDbycreateQuestion: (state) => state.ques_id,
  getIDbycreateQuestionoption: (state) => state.option_id,
  // ANCHOR Mutation
  getIDbyCreateNewGallery: (state) => state.s_gallerys,
  getIDbyUpdateGallery: (state) => state.s_gallerys,
  getIDbyCreateNewGalleryPage: (state) => state.s_gallery_page,
  getIDbyUpdateGalleryPage: (state) => state.s_gallery_page,

  getGallerysN: (state) => state.s_getGallerys,
  getGalleryPagesN: (state) => state.s_getGalleryPages,
};

var user_context = JSON.parse(localStorage.getItem("user_context"));
var uid = localStorage.getItem("uid");
var pass = localStorage.getItem("pass");

//actions
export var quizActions = {
  async getquizButtons({ commit }) {
    commit("quiz_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz.button', 'search_read', [], [
              "id",
              "display_name",
              "button_type",
              "button_code",
              "button_outline",
              "button_size",
              "button_text",
              "description",
            ],
            0,
            0,
            ""
        ]
      }
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var button_data = res.data.result;
        ////console.log("res quiz.button", res);
        var buttons = [];
        if (button_data.length > 0) {
          buttons = button_data;
        }
        commit("buttons_success", buttons);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getQuestionDetails({ commit }, payload) {
    commit("quiz_request");
    var domain = [];
    var { question_ids } = payload;

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'etq.question', 'read', question_ids, [] ]
      },
    };

    var domain = [];
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("11111111111", res);
        var questions = [];
        if (res.data.result.length > 0) {
          questions = res.data.result;
        }
        commit("quiz_question_success", questions);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getQuestionOptions({ commit }, payload) {
    commit("quiz_request");
    var domain = [];
    var { option_ids } = payload;

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'etq.question.option', 'read', option_ids, [] ]
      },
    };

    var domain = [];
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("11111111111", res);
        var options = [];
        if (res.data.result.length > 0) {
          options = res.data.result;
        }
        commit("quiz_option_success", options);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getImages({ commit }) {
    commit("quiz_request");
    var domain = [];

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.image', 'search_read', domain, ["id", "name", "image_url", "description"],
            0,
            0,
            ""
        ]
      },
    };
    // //console.log("11111111111", req_data);
    var domain = [];
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("11111111111", res);
        var images = [];
        if (res.data.result.length > 0) {
          images = res.data.result;
        }
        commit("images_success", images);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getQuizes({ commit }, payload) {
    commit("quiz_request");
    var { partner_ids, quiz_ids, create_date } = payload;
    // //console.log("payload ::: ",payload);
    // var domain = [["partner_id", "!=", false]];
    var domain = [];
    // //console.log("payload :::: ",payload);
    if (partner_ids.length > 0) {
      domain.push(["partner_id", "in", partner_ids]);
    }
    if (quiz_ids.length > 0) {
      domain.push(["id", "in", quiz_ids]);
    }
    if (create_date.length > 0) {
      domain.push(["create_date", ">=", `${create_date[0]}`]);
      domain.push(["create_date", "<=", `${create_date[1]}`]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz', 'search_read', domain, [
                "id",
                "name",
                "plataform",
                "business_unit_id",
                "url_gmb_status",
                "translate",
                "translate_lenguage",
                "slug2",
                "html_preview",
                "rank_quiz",
                "location_id",
                "title_img",
                "quiz_type",
                "loader_time",
                "show_thankyoupage",
                "show_offer_thankyoupage",
                "text_thankyoupage",
                "heading_thankyoupage",
                "heading_offer_thankyoupage",
                "subtitle_offer_thankyoupage",
                "text_offer_thankyoupage",
                "diferent_url_offer_thankyoupage",
                "url_offer_thankyoupage",
                "subtitle_thankyoupage",
                "link",
                "questions",
                "image_id",
                "stat_ids",
                "partner_id",
                "create_date",
                "thankyoupage_button",
                "offer_thankyoupage_button",
                "confirmation_button",
                "subtitle",
                "title_img",
                "font_family",
                "font_family_url",
                "url_quiz_completion_id",
                "pre_redirect",
                "query",
                "loader_time",
                "html_head_analytics",
                "html_body_analytics",
                "html_under_answer",
                "questions_gallery_ids",
                "css_page_background",
                "css_top_bar",
                "css_top_bar_color",
                "title_background",
                "title_font_color",
                "title_font_size",
                "subtitle_font_color",
                "subtitle_font_size",
                "question_background",
                "question_font_color",
                "question_font_size",
                "option_background",
                "option_font_color",
                "option_font_size",
                "show_confirmation",
                "heading_confirmation",
                "subtitle_confirmation",
                "text_confirmation",
                "confirmmation_image_id",
                "thankyoupage_image_id",
                "offer_thankyoupage_image_id",
                "html_code_confirmation",
                "html_button_code_confirmation",
                "show_confirmation_last_page",
                "page_background_confirmation",
                "heading_confirmation_background",
                "heading_confirmation_font_color",
                "heading_confirmation_font_size",
                "subtitle_confirmation_background",
                "subtitle_confirmation_font_color",
                "subtitle_confirmation_font_size",
                "text_confirmation_background",
                "text_confirmation_font_color",
                "text_confirmation_font_size",
                "bottom_show",
                "html_code_bottom_bar",
                "bottom_bar_background",
                "bottom_bar_font_color",
                "display_name",
                "background_img",
                "image_id",
                "domain_id",
                "country_id",
                "gallery_button",
            ],
            0,
            0,
            ""
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data ::: ", res.data.result);
        var quizes = [];
        if (res.data.result.length > 0) quizes = res.data.result;
        commit("quiz_success", quizes);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },

  async getcommenzadosCount({ commit }, quiz_id) {
    commit("quiz_request");

    var domain = [];
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat_uuid', 'read_group', [], [], ['quiz_id'], 0,0,'',false],
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data getcommenzadosCount::: ", res.data.result);
        var getcommenzadosCount = [];
        if (res.data.result.length > 0) {
          getcommenzadosCount = res.data.result;
        }
        commit("quiz_commenzadosCount_success", getcommenzadosCount);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },

  async getImagebyQuiz({ commit }, quiz_ids) {
    commit("quiz_request");
    // //console.log("quiz_ids in service", quiz_ids);
    var domain = [];
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.image', 'read', quiz_ids, ["id", "image", "image_url"]],
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res.data getImagebyQuiz::: ", res.data);
        var getImagebyQuiz = [];
        if (res.data.result.length > 0) {
          getImagebyQuiz = res.data.result;
        }
        commit("quiz_imagebyQuiz_success", getImagebyQuiz);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getGraphdatabyQuiz({ commit }, payload) {
    commit("quiz_request");
    var { value, quiz_id } = payload;
    //console.log("quiz_ids in service", quiz_id);
    var model = "apache.quiz.stat_overview";
    if (value === "Day") model = "apache.quiz.stat_overview";
    if (value === "Month") model = "apache.quiz.stat_overview_month";
    if (value === "Year") model = "apache.quiz.stat_overview_year";

    var domain = [];
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, model, 'search_read', [["quiz_id", "=", quiz_id]], [], 0, 0, ""]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data graphdatabyQuiz::: ", res.data);
        var graphdatabyQuiz = [];
        if (res.data.result.length > 0) {
          graphdatabyQuiz = res.data.result;
        }
        commit("quiz_graphdatabyQuiz_success", graphdatabyQuiz);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getRespustasCount({ commit }, quiz_id) {
    commit("quiz_request");

    var domain = [];
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat', 'search_count', [["quiz_id", "=", quiz_id]] ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data getRespustasCount::: ", res.data.result);
        var respustasCount = 0;
        if (res.data.result) respustasCount = res.data.result;
        commit("quiz_respustasCount_success", respustasCount);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getparaCompletar({ commit }, quiz_id) {
    commit("quiz_request");

    var domain = [];
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat_overview_year', 'search_read', [["quiz_id", "=", quiz_id]], ['avg_time'],
            0,
            0,
            ""
        ]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data getparaCompletar::: ", res.data.result);
        var paraCompletar = [];
        if (res.data.result.length > 0) paraCompletar = res.data.result;
        commit("quiz_paraCompletar_success", paraCompletar);
        return res.data.result;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getCompletadosCount({ commit }, quiz_id) {
    commit("quiz_request");

    var domain = [];
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat', 'search_count', [
            ["quiz_id", "=", quiz_id],
            ["answerlist", "!=", false],
          ] ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data ::: ", res.data.result);
        var completadosCount = 0;
        if (res.data.result) completadosCount = res.data.result;
        commit("quiz_completadosCount_success", completadosCount);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },

  async respustasDelete({ commit, state }, payload) {
    commit("quiz_request");
    var { answers } = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat', 'unlink', answers]
      },
    };

    ////console.log("review_id in getreviewDelete :::: ", review_id);
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("check res in replywizard delete", res);
        if (res.data.result == true) {
          //console.log("state.uuids res::: ", state.respustasData);
          var uuids = state.respustasData;
          // uuids.forEach((uuid)=>{
          //   var index = uuids.findIndex(element => {
          //     return element.id == uuid;
          //   });
          //   uuids.splice(index, 1);
          // })
          // //console.log("uuids :::: ", uuids);
          commit("quiz_delete_success", uuids);
          return uuids;
        } else {
          commit("quiz_error");
        }
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
    // },
  },
  async removeOption({ commit, state }, option_id) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'etq.question.option', 'unlink', [option_id]]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("check res in replywizard delete", res);
        if (res.data.result == true) {
          commit("quiz_option_delete_success", res.data.result);
        } else {
          commit("quiz_error");
        }
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
    // },
  },
  async getRespustasData({ commit }, payload) {
    commit("quiz_request");
    // var quiz_id =quiz_ids;
    var { quiz_id, create_date } = payload;
    //console.log("quiz_ids in service", quiz_id, user_context);

    var domain = [["quiz_id", "=", Number(quiz_id)]];
    if (create_date.length > 0) {
      domain.push(["create_date", ">=", create_date[0]]);
      domain.push(["create_date", "<=", create_date[1]]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat_uuid', 'search_read', domain, [], 0, 0, "create_date desc" ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("res.data getRespustasData::: ", res.data);
        var respustasData = [];
        if (res.data.result.length > 0) {
          respustasData = res.data.result;
        }
        commit("quiz_respustasData_success", respustasData);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },

  async getRespustasAnswerData({ commit }, payload) {
    commit("quiz_request");
    var { quiz_ids, uuids, create_date } = payload;

    //console.log("quiz_ids in service ::::", quiz_ids, uuids);
    var domain = [
      ["quiz_id", "=", quiz_ids],
      ["uuid", "in", uuids],
    ];
    if (create_date.length > 0) {
      domain.push(["create_date", ">=", create_date[0]]);
      domain.push(["create_date", "<=", create_date[1]]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat', 'search_read', domain, [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var respustasAnswerData = [];
        if (res.data.result.length > 0) {
          respustasAnswerData = res.data.result;
        }
        //console.log("res.data getRespustasAnswerData::: ", respustasAnswerData);
        commit("quiz_respustasad_success", respustasAnswerData);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },

  async getUUIDData({ commit }, payload) {
    commit("quiz_request");
    var { quiz_ids } = payload;
    //console.log("quiz_ids in service", quiz_ids);
    var domain = [];
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context,
        model: "apache.quiz.stat_uuid",
        domain: [["quiz_id", "=", quiz_ids]],
        fields: [
          "quiz_id",
          "id",
          "partner_id",
          "location_id",
          "business_unit_id",
          "uuid",
          "create_date",
          "display_name",
          "__last_update",
        ],
        sort: "create_date desc",
        limit: 0,
      },
    };

    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        //console.log("res.data getUUIDData::: ", res.data);
        var UUIDData = [];
        if (res.data.result.length > 0) {
          UUIDData = res.data.result;
        }
        commit("quiz_uuidData_success", UUIDData);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },

  async getQuizesbyPartner({ commit }, partner_ids) {
    commit("quiz_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz', 'search_read', [["partner_id", "=", partner_ids]], ["id", "name", "slug2", "html_preview", "location_id"],0,0,""]
      },
    };
    //console.log("req_data in quiz by partner", req_data);
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var quizes = [];
        //console.log("res in quz by partner", res.data);
        if (res.data.result.length > 0) {
          quizes = res.data.result;
        }
        commit("quiz_successbypartner", quizes);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getQuizstatFinish({ commit }, payload) {
    commit("quiz_request");
    var { partner_ids, quiz_ids, create_date } = payload;
    var domain = [];

    if (partner_ids.length > 0) {
      domain.push(["partner_id", "in", partner_ids]);
    }
    if (quiz_ids.length > 0) {
      domain.push(["quiz_id", "in", quiz_ids]);
    }
    if (create_date.length > 0) {
      domain.push(["create_date", ">=", `${create_date[0]}`]);
      domain.push(["create_date", "<=", `${create_date[1]}`]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat_uuid', 'read_group', domain
        , [], ["create_date:day"], 0,0,'',false ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var quiz_stat = res.data.result;
        ////console.log("resdata quiz stat finish :::::: ", res.data);
        commit("quiz_stat_success", quiz_stat);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getstatOverview({ commit }, payload) {
    commit("quiz_request");
    //console.log("payload in getstatOverview::: ", payload);
    var { quiz_id, graph_type } = payload;
    var domain = [];

    // if(partner_ids.length >0){
    //       // domain.push(["partner_id", "in", partner_ids]);
    //       domain.push(["quiz_id","in", [1]]);
    // }
    // if(quiz_ids.length>0){
    //   domain.push(["quiz_id","in", quiz_ids]);
    // }
    // if(create_date.length>0){
    //     domain.push(["create_date",">=",`${create_date[0]}`])
    //     domain.push(["create_date","<=",`${create_date[1]}`])

    // }
    var model = "apache.quiz.stat_overview";
    if (graph_type === "Day") {
      model = "apache.quiz.stat_overview";
    }
    if (graph_type === "Month") {
      model = "apache.quiz.stat_overview_month";
    }
    if (graph_type === "Year") {
      model = "apache.quiz.stat_overview_year";
    }

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, model, 'search_read', [["quiz_id", "=", quiz_id]], [],0,0,""]
      },
    };
    //console.log("req_data :::: ", req_data);

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var quiz_stat_group = [];
        if (res.data.result.length > 0) {
          quiz_stat_group = res.data.result;
        }
        //console.log(    res.data.result,    quiz_stat_group,    "::::::::::res getstatOverview" );
        commit("overview_success", quiz_stat_group);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async getQuizstatGroupby({ commit }, payload) {
    commit("quiz_request");
    //console.log("payload in groupby::: ", payload);
    var { partner_ids, quiz_ids, create_date } = payload;
    var domain = [];

    if (partner_ids.length > 0) {
      domain.push(["partner_id", "in", partner_ids]);
      // domain.push(["quiz_id","in", [1]]);
    }
    if (quiz_ids.length > 0) {
      domain.push(["quiz_id", "in", quiz_ids]);
    }
    if (create_date.length > 0) {
      domain.push(["create_date", ">=", `${create_date[0]}`]);
      domain.push(["create_date", "<=", `${create_date[1]}`]);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'apache.quiz.stat_group_by', 'search_read', domain, [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        // ////console.log(res, "::::::::::res 204");
        var quiz_stat_group = [];
        if (res.data.result.length > 0) {
          quiz_stat_group = res.data.result;
        }
        commit("quiz_statg_success", quiz_stat_group);
        return res;
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async crearQuizButton({ commit, state }, button) {
    commit("quiz_request");
    //falta agregar gallery_ids
    var {
      button_type,
      button_outline,
      button_size,
      button_text,
      button_code,
      description,
    } = button;
    // //console.log("button 123:::: ", button);

    // var formData = new FormData();

    if (button.refc && button.refc == true) {
      var new_button = {
        button_type: button_type ? button_type.value : "",
        button_outline: button_outline ? "True" : "False",
        button_size: button_size ? button_size.value : "",
        button_text: button_text,
        description: description,
        button_code: button_code,
      };
    } else {
      var new_button = `{
        'button_type':'${button_type ? button_type.value : ""}',
        'button_outline':'${button_outline ? "True" : "False"}' ,
        'button_size':'${button_size ? button_size.value : ""}',
        'button_text':'${button_text}',
        'description':'${description}',
        'button_code':'${button_code}'
        }`;
    }

    // formData.append("data", new_button);
    //console.log("new data ::: ", new_button);
    // //console.log("new data ::: ", JSON.parse(new_button));
    // var new_button = JSON.parse(new_button)

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'apache.quiz.button', 'create', new_button ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("quiz button res ::: ", res);
        if (res.status == 201) {
          button.id = res.data.id;
          var buttons = state.buttons;

          buttons.push(button);
          commit("button_success", buttons);
          return buttons;
        } else {
          commit("quiz_error");
        }
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async newQuizPreview({ commit, state }, quiz) {
    var { name, quiz_type, slug2, url_quiz_completion_id, domain_id } = quiz;
    var new_quiz = {
      name: `${name}`,
      quiz_type: `${quiz_type}`,
      slug2: `${slug2}`,
      url_quiz_completion_id: `${url_quiz_completion_id}`,
      domain_id: domain_id,
      font_family: "Roboto",
    };
    // var new_quiz_data = JSON.parse(new_quiz);
    // //console.log("new_quiz_data :::: ", new_quiz_data);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz', 'create', [new_quiz]]
      },
    };
    //console.log(req_data, " ::::: payload quiz 1100");

    // let formData = new FormData();
    // formData.append("data", new_quiz);
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(async (res) => {
        if (res.status == 200 && res.statusText === "OK") {
          var id = res.data.result;
          console.log("res new quiz ::::: ", res.data.result);
          // var quizes = state.quizes;
          // quizes.push(new_quiz);

          // commit("quiz_success", quizes);
          commit("quiz_create_success", id);
        } else {
          commit("quiz_error");
        }
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async editQuizsinglefield({ commit, state }, payload) {
    commit("quiz_request");
    //console.log("payload in editsinglefield :::: ", payload);
    var { payload_data, id } = payload;
    var field_change = payload_data;

    // //console.log(field_change, this, " ::::::: field_change");
    // let formData = new FormData();
    // formData.append("data", field_change);
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz', 'write', id, payload_data]
      },
    };
    const peticion_quiz = this._vm.$http
      .post("/jsonrpc", req_data)
      .then(async (res) => {
        if (res.status === 200) {
          let quizes = state.quizes;
          commit("quiz_success", quizes);
        } else {
        }
        return res.status;
      });
  },

  async getIDbycreateQuestion({ commit, state }, question) {
    commit("quiz_request");
    //console.log("payload in createquestion :::: ", question);

    delete question.question_status
    delete question.question_options
    delete question.question_options_blank
    delete question.question_options_data

    question.exam_id = question.exam_id[0]
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'etq.question', 'create', question ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(async (res) => {
        //console.log("res :::: ", res);
        if (res.data.result) {
          commit("quiz_ques_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },
  async editQuestionsinglefield({ commit, state }, payload) {
    commit("quiz_request");
    //console.log("payload in editsinglequestionfield :::: ", payload);
    var { payload_data, ques_id } = payload;
    var field_change = payload_data;

    field_change.exam_id = field_change.exam_id[0]

    //console.log(field_change, this, " ::::::: field_change");
    let formData = new FormData();
    formData.append("data", field_change);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'etq.question', 'write', [ques_id], payload_data]
      },
    };
    const peticion_quiz = this._vm.$http
      .post("/jsonrpc", req_data)
      .then(async (res) => {
        if (res.status === 200) {
          let quizes = state.quizes;
          commit("quiz_success", quizes);
        } else {
        }
        return res.status;
      });
  },
  async getIDbycreateQuestionoption({ commit, state }, payload) {
    commit("quiz_request");
    //console.log("payload in createQuestionOptionsinglefield :::: ", payload);
    var { option, question_id } = payload;
    option["question_id"] = question_id;

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'etq.question.option', 'create', option ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(async (res) => {
        //console.log("res optionscreate :::: ", res);
        if (res.data.result) {
          // let quizes = state.quizes;

          commit("quiz_option_id_success", res.data.result);
          return res.status;
        }
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  async editQuestionOptionsinglefield({ commit, state }, payload) {
    commit("quiz_request");
    //console.log("payload in editsinglequestionfield :::: ", payload);
    var { payload_data, ques_id } = payload;
    var field_change = payload_data;

    //console.log(field_change, this, " ::::::: field_change");
    let formData = new FormData();
    formData.append("data", field_change);

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',        
        args: [axios.defaults.db, uid, pass, 'etq.question.option', 'write', [ques_id], payload_data ]
      },
    };
    const peticion_quiz = this._vm.$http
      .post("/jsonrpc", req_data)
      .then(async (res) => {
        if (res.data.result === true) {
          let quizes = state.quizes;
          commit("quiz_success", quizes);
        } else {
        }
        return res.status;
      });
  },
  async editQuiz({ commit, state }, quiz) {
    commit("quiz_request");
    var {
      id,
      domain_id,
      name,
      quiz_type,
      //quiz_model,
      partner_id,
      confirmation_button,
      thankyoupage_button,
      promotion_id,
      country_id,
      location_id,
      subtitle1,
      subtitle,
      slug2,
      url_quiz_completion_id,
      loader_time,

      html_head_analytics,
      html_body_analytics,
      heading_confirmation,
      subtitle_confirmation,
      heading_confirmation_background,
      background_img,
      confirmmation_image_id,
      text_confirmation_background,
      text_confirmation,

      show_confirmation,
      show_thankyoupage,
      text_thankyoupage,
      heading_thankyoupage,
      subtitle_thankyoupage,

      heading_offer_thankyoupage,
      subtitle_offer_thankyoupage,
      offer_thankyoupage_image_id,
      text_offer_thankyoupage,
      diferent_url_offer_thankyoupage,
      url_offer_thankyoupage,
      offer_thankyoupage_button,

      thankyoupage_image_id,
      image_id,
      page_background_confirmation_img,
      title_img,
      font_family,
      font_family_url,

      title_background,
      title_font_color,
      title_font_size,
      subtitle_font_color,
      subtitle_font_size,
      question_background,
      question_font_color,
      question_font_size,
      option_background,
      option_font_color,
      option_font_size,

      text_thankyoupage_font_size,
      text_thankyoupage_font_color,
      text_thankyoupage_background,
      subtitle_thankyoupage_font_size,
      subtitle_thankyoupage_font_color,
      subtitle_thankyoupage_background,
      heading_thankyoupage_font_size,
      heading_thankyoupage_font_color,
      heading_thankyoupage_background,
      page_background_thankyoupage,
      page_background_thankyoupage_img,

      page_background_confirmation,
      heading_confirmation_background,
      heading_confirmation_font_color,
      heading_confirmation_font_size,
      subtitle_confirmation_background,
      subtitle_confirmation_font_color,
      subtitle_confirmation_font_size,
      text_confirmation_background,
      text_confirmation_font_color,
      text_confirmation_font_size,

      html_under_answer,
      rank_quiz,
      show_offer_thankyoupage,
      questions_gallery_ids,
      questions,
      questions_update,

      plataform,
      business_unit_id,
      url_gmb_status,
      translate,
      translate_lenguage,
    } = quiz;
    let display_name = "";
    let link = "";
    let formData = new FormData();
    //'quiz_model': '${quiz_model}',
    //console.log("questions_gallery_ids", questions_gallery_ids);

    var new_quiz = {
      name: `${name}`,
      partner_id: Number(partner_id),
      confirmation_button: Number(confirmation_button),
      thankyoupage_button: Number(thankyoupage_button),

      link: `${link}`,
      domain_id: Number(domain_id),
      slug2: `${slug2}`,
      country_id: Number(country_id),
      quiz_type: `${quiz_type}`,

      url_quiz_completion_id: url_quiz_completion_id,
      subtitle: `${subtitle}`,
      loader_time: `${loader_time}`,

      html_head_analytics: `${html_head_analytics}`.replaceAll(
        /(\r\n|\n|\r)/gm,
        "\\n"
      ),

      html_body_analytics: `${html_body_analytics}`.replaceAll(
        /(\r\n|\n|\r)/gm,
        "\\n"
      ),

      heading_confirmation: `${heading_confirmation}`,
      subtitle_confirmation: `${subtitle_confirmation}`,
      heading_confirmation_background: `${heading_confirmation_background}`,

      text_confirmation_background: `${text_confirmation_background}`,
      text_confirmation: `${text_confirmation}`,

      font_family: `${font_family}`,
      font_family_url: `${font_family_url}`,

      show_confirmation: show_confirmation,
      show_thankyoupage: show_thankyoupage,
      text_thankyoupage: `${text_thankyoupage}`,
      heading_thankyoupage: `${heading_thankyoupage}`,
      subtitle_thankyoupage: `${subtitle_thankyoupage}`,

      heading_offer_thankyoupage: `${heading_offer_thankyoupage}`,
      subtitle_offer_thankyoupage: `${subtitle_offer_thankyoupage}`,
      text_offer_thankyoupage: `${text_offer_thankyoupage}`,
      diferent_url_offer_thankyoupage: diferent_url_offer_thankyoupage,
      url_offer_thankyoupage: `${url_offer_thankyoupage}`,
      offer_thankyoupage_button: Number(offer_thankyoupage_button),

      text_thankyoupage_font_size: `${text_thankyoupage_font_size}`,
      text_thankyoupage_font_color: `${text_thankyoupage_font_color}`,
      text_thankyoupage_background: `${text_thankyoupage_background}`,
      subtitle_thankyoupage_font_size: `${subtitle_thankyoupage_font_size}`,
      subtitle_thankyoupage_font_color: `${subtitle_thankyoupage_font_color}`,
      subtitle_thankyoupage_background: `${subtitle_thankyoupage_background}`,
      heading_thankyoupage_font_size: `${heading_thankyoupage_font_size}`,
      heading_thankyoupage_font_color: `${heading_thankyoupage_font_color}`,
      heading_thankyoupage_background: `${heading_thankyoupage_background}`,
      page_background_thankyoupage: `${page_background_thankyoupage}`,

      page_background_confirmation_img: Number(
        page_background_confirmation_img
      ),
      page_background_thankyoupage_img: Number(
        page_background_thankyoupage_img
      ),

      background_img: Number(background_img),
      confirmmation_image_id: Number(confirmmation_image_id),
      offer_thankyoupage_image_id: Number(offer_thankyoupage_image_id),
      thankyoupage_image_id: Number(thankyoupage_image_id),
      image_id: Number(image_id),

      page_background_confirmation: `${page_background_confirmation}`,
      heading_confirmation_background: `${heading_confirmation_background}`,
      heading_confirmation_font_color: `${heading_confirmation_font_color}`,
      heading_confirmation_font_size: `${heading_confirmation_font_size}`,
      subtitle_confirmation_background: `${subtitle_confirmation_background}`,
      subtitle_confirmation_font_color: `${subtitle_confirmation_font_color}`,
      subtitle_confirmation_font_size: `${subtitle_confirmation_font_size}`,
      text_confirmation_background: `${text_confirmation_background}`,
      text_confirmation_font_color: `${text_confirmation_font_color}`,
      text_confirmation_font_size: `${text_confirmation_font_size}`,

      html_under_answer: `${html_under_answer}`,
      rank_quiz: rank_quiz,
      show_offer_thankyoupage: show_offer_thankyoupage,

      plataform: Number(plataform !== undefined ? plataform : 1),
      url_gmb_status: url_gmb_status,
      translate: translate,
      translate_lenguage: `${
        translate_lenguage !== undefined ? translate_lenguage : ""
      }`,
      business_unit_id: `${
        business_unit_id !== undefined ? Number(business_unit_id) : ""
      }`,
      location_id: `${location_id !== undefined ? Number(location_id) : ""}`,

      title_img: Number(title_img),
      title_background: `${title_background}`,
      title_font_color: `${title_font_color}`,
      title_font_size: `${title_font_size}`,
      subtitle_font_color: `${subtitle_font_color}`,
      subtitle_font_size: `${subtitle_font_size}`,
      question_background: `${question_background}`,
      question_font_color: `${question_font_color}`,
      question_font_size: `${question_font_size}`,
      option_background: `${option_background}`,
      option_font_size: `${option_font_size}`,
      option_font_color: `${option_font_color}`,
    };
    // 'relational_fields': [
    //                       ('partner_id', 'res.partner'),
    //                       ('domain_id', 'apache.domain'),
    //                       ('country_id', 'res.country'),
    //                       ('confirmation_button', 'apache.quiz.button'),
    //                       ('thankyoupage_button', 'apache.quiz.button'),
    //                       ('offer_thankyoupage_button', 'apache.quiz.button'),
    //                       ('title_img', 'apache.image'),
    //                       ('page_background_confirmation_img', 'apache.image'),
    //                       ('confirmmation_image_id', 'apache.image'),
    //                       ('offer_thankyoupage_image_id', 'apache.image'),
    //                       ('thankyoupage_image_id', 'apache.image'),
    //                       ('image_id', 'apache.image'),
    //                       ('page_background_thankyoupage_img', 'apache.image'),
    //                       ('background_img', 'apache.image'),
    //                     ],
    // 'questions_gallery_ids': ${questions_gallery_ids},

    //console.log("new_quiz", new_quiz);
    formData.append("data", new_quiz);
    let peticiones = [];
    let createQuestions = async (questions, id) => {
      //console.log("question in create ::: ", questions);
      questions.map((question) => {
        //console.log("question in create ::: ", question, question.image_id);
        let formData1 = new FormData();
        let data = "";
        let data1 = "";
        let peticion = "";

        if (
          question.image_id !== undefined &&
          question.image_id !== "" &&
          question.image_id !== null
        ) {
          if (question.scale == true) {
            data = {
              exam_id: Number(id),
              sequence: question.sequence,
              image_id: question ? Number(question.image_id) : null,
              question_text: question.question_text,
              scale: question.scale,
              scale_type:
                question.scale_type !== undefined ? question.scale_type : "",
              scale_offer: question.scale_offer,
            };
            // 'relational_fields': [
            //   ('image_id', 'apache.image'),
            //   ('question_options_blank','etq.question.optionblank')
            // ],
          } else {
            if (question.question_type == "fill_blank") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,
                image_id: question ? Number(question.image_id) : null,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
              };
              // 'relational_fields': [
              //   ('image_id', 'apache.image')
              // ]
            } else if (question.question_type == "multi_choice") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,
                image_id: question ? Number(question.image_id) : null,
                others: question.others,
                // 'question_options': question.question_options,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
              };
              data1 = {
                question_options: question.question_options,
              };
              // 'relational_fields': [
              //   ('image_id', 'apache.image'),
              //   ('question_options','etq.question.option')
              // ],
            } else {
            }
          }
        } else {
          if (question.scale == true) {
            data = {
              exam_id: Number(id),
              sequence: question.sequence,
              question_text: question.question_text,
              scale: question.scale,
              scale_type:
                question.scale_type !== undefined ? question.scale_type : "",
              scale_offer: question.scale_offer,
            };
            // 'relational_fields': [
            //   ('question_options_blank','etq.question.optionblank')
            // ],
          } else {
            if (question.question_type == "fill_blank") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
              };
            } else if (question.question_type == "multi_choice") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,
                others: question.others,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
              };
              data1 = {
                question_options: question.question_options,
              };
              // 'relational_fields': [
              //   ('question_options','etq.question.option')
              // ],
            } else {
            }
          }
        }

        // formData1.append("data", data);

        // if(data1.question_options.length>0)

        var qoption_ids = [];
        if (
          data1.question_options !== undefined &&
          data1.question_options != ""
        ) {
          //console.log("question.question_options.length", data1);
          // data1.question_options.forEach((option)=>{
          //   //console.log("option //console ::: ", option);

          //   var req_data1 = {
          //             "jsonrpc": "2.0",
          //             "method": "call",
          //             "params": {
          //                 "kwargs":{"context":user_context.user_context},
          //                 "args": data1.question_options,
          //                 "method": "create",
          //                 "model": "etq.question.option"
          //             }
          //           }
          // //console.log("req_data1 orptions :: ", req_data1);
          // // let peticion1 = this._vm.$http.put("/web/dataset/call_kw/write", req_data1);
          // let  peticion1 = this._vm.$http.post("/web/dataset/call_kw/create", req_data1)

          // });
          var req_data1 = {
            jsonrpc: "2.0",
            method: "call",
            params: {
              service: 'object',
              method: 'execute',        
              args: [axios.defaults.db, uid, pass, 'etq.question', 'create', data ]
            },
          };
          //console.log("req_data question ::: ", req_data1);

          peticion = this._vm.$http
            .post("/jsonrpc", req_data1)
            .then((res) => {
              var ques_id = res.data.result;
              data1.question_options.forEach((option) => {
                //console.log("option //console ::: ", option);
                // if (option.status === "I"){
                var req_data1 = {
                  jsonrpc: "2.0",
                  method: "call",
                  params: {
                    service: 'object',
                    method: 'execute',        
                    args: [axios.defaults.db, uid, pass, 'etq.question.option', 'create', {
                        question_id: ques_id,
                        option: option.option,
                        correct: option.correct,
                        value: option.value,
                      }]
                  },
                };
                //console.log("req_data1 orptions :: ", req_data1);
                let peticion1 = this._vm.$http
                  .post("/jsonrpc", req_data1)
                  .then((res) => {
                    // //console.log("res data question: ", res);
                    // qoption_ids.push(res.data.result);
                    // var req_quest_update ={
                    //                        "jsonrpc": "2.0",
                    //                        "method": "call",
                    //                        "params": {
                    //                            "kwargs":{
                    //                                "context":user_context.user_context
                    //                                },
                    //                            "args": [[ques_id], {"question_option": qoption_ids}], //(Record ID and field to update)
                    //                            "method": "write",
                    //                            "model": "etq.question"
                    //                        }
                    //                    }
                    // let peticionupdate = this._vm.$http.post("/web/dataset/call_kw/write", req_quest_update);
                  });

                // }
              });
            });
        }
        data["question_option"] = [[6, false, qoption_ids]];
        //console.log("data question :::: ", data);

        peticiones.push(peticion);
      });
    };
    let updateQuestions = async (questions_update, id) => {
      questions_update.map((question) => {
        let formData1 = new FormData();
        let data = "";
        let data1 = "";
        //console.log("question :::: ", questions_update);
        if (
          question.image_id !== undefined &&
          question.image_id !== "" &&
          question.image_id !== null
        ) {
          if (question.scale == true) {
            data = {
              exam_id: Number(id),
              sequence: question.sequence,
              image_id: question ? question.image_id : null,
              question_text: question.question_text,
              scale: question.scale,
              scale_type:
                question.scale_type !== undefined ? question.scale_type : "",
              scale_offer: question.scale_offer,
            };
            // 'relational_fields': [
            //   ('image_id', 'apache.image'),
            // ],
          } else {
            if (question.question_type == "fill_blank") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,
                image_id: question ? question.image_id : null,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
              };
              // 'relational_fields': [
              //     ('image_id', 'apache.image'),
              //   ],
            } else if (question.question_type == "multi_choice") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,
                image_id: question ? question.image_id : null,
                others: question.others,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
                question_option: [[6, false, question.question_options]],
              };
              if (
                question.question_options !== undefined &&
                question.question_options.length > 0
              ) {
                data1 = {
                  question_options: question.question_options_data,
                };
              }
              // 'relational_fields': [
              //   ('image_id', 'apache.image'),
              //   ('question_options','etq.question.option')
              // ],
            } else {
            }
          }
        } else {
          if (question.scale == true) {
            data = {
              exam_id: Number(id),
              sequence: question.sequence,
              question_text: question.question_text,
              scale: question.scale,
              scale_type:
                question.scale_type !== undefined ? question.scale_type : "",
              scale_offer: question.scale_offer,
            };
          } else {
            if (question.question_type == "fill_blank") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
              };
            } else if (question.question_type == "multi_choice") {
              data = {
                exam_id: Number(id),
                sequence: question.sequence,

                others: question.others,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type
                    : "",
                scale_offer: question.scale_offer,
                question_option: [[6, false, question.question_options]],
              };
              if (
                question.question_options !== undefined &&
                question.question_options.length > 0
              ) {
                data1 = {
                  question_options: question.question_options_data,
                };
              }
              // 'relational_fields': [
              //   ('question_options','etq.question.option')
              // ],
            } else {
            }
          }
        }
        let ques_id = question.id;
        let question_options = question.question_options;
        //console.log("question_options ::: ", question_options);
        // formData1.append("data", data);
        var req_data = {
          jsonrpc: "2.0",
          method: "call",
          params: {
            service: 'object',
            method: 'execute',        
            args: [axios.defaults.db, uid, pass, 'etq.question', 'write', [ques_id], data ]
          },
        };

        let peticion = this._vm.$http.post(
          "jsonrpc",
          req_data
        );
        let peticion1 = "";
        if (
          question.question_options !== undefined &&
          question.question_options.length > 0
        ) {
          //console.log("question.question_options.length", data1);
          data1.question_options.forEach((option) => {
            //console.log("option //console ::: ", option);
            if (option.status === "U") {
              var req_data1 = {
                jsonrpc: "2.0",
                method: "call",
                params: {
                  service: 'object',
                  method: 'execute',        
                  args: [axios.defaults.db, uid, pass, 'etq.question.option', 'write', [option.id],
                    {
                      question_id: ques_id,
                      option: option.option,
                      correct: option.correct,
                      value: option.value,
                    },  ]
                },
              };
              //console.log("req_data1 orptions :: ", req_data1);
              let peticion1 = this._vm.$http.post(
                "jsonrpc",
                req_data1
              );
            }
            if (option.status === "I") {
              var req_data1 = {
                jsonrpc: "2.0",
                method: "call",
                params: {
                  service: 'object',
                  method: 'execute',        
                  args: [axios.defaults.db, uid, pass, 'etq.question.option', 'create', 
                    {
                      question_id: ques_id,
                      option: option.option,
                      correct: option.correct,
                      value: option.value,
                    },
                  ]
                },
              };
              //console.log("req_data1 orptions :: ", req_data1);
              let peticion1 = this._vm.$http
                .post("/jsonrpc", req_data1)
                .then((res) => {
                  // //console.log("res data question: ", res);
                  // question.question_options.push(res.data.result);
                  // var req_quest_update ={
                  //                        "jsonrpc": "2.0",
                  //                        "method": "call",
                  //                        "params": {
                  //                            "kwargs":{
                  //                                "context":user_context.user_context
                  //                                },
                  //                            "args": [[ques_id], {"question_option": question.question_options}], //(Record ID and field to update)
                  //                            "method": "write",
                  //                            "model": "etq.question"
                  //                        }
                  //                    }
                  // let peticionupdate = this._vm.$http.post("/web/dataset/call_kw/write", req_quest_update);
                });
            }
          });
        }
        // if(peticion.result)
        peticiones.push(peticion);
        // else
        //   //console.log("error in updating question", peticiones);

        //   // let peticion = this._vm.$http.put(`/apache/rest_api/etq.question`, formData1,{
        //   // headers: {},
        //   // params: {
        //   //   ids: `[${ques_id}]`
        //   // }
        // })
        // peticiones.push(peticion);
        // })
        // 'question_options_blank': ${question.question_options_blank},

        // ('image_id', 'apache.image'),
        //         ('exam_id', 'apache.quiz'),
        //         ('question_options','etq.question.option'),
      });
    };
    if (questions.length > 0) {
      ////console.log("entro al if")
      ////console.log(questions)
      await createQuestions(questions, id);
    }
    if (questions_update.length > 0) {
      ////console.log("entro al if")
      //console.log("questions_update ::: ", questions_update);
      await updateQuestions(questions_update, id);
    }
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz', 'write', id, new_quiz]
      },
    };

    const peticion_quiz = this._vm.$http
      .post("/jsonrpc", req_data)
      .then(async (res) => {
        ////console.log("res::::::::", res, res.length, res.status);
        if (res.status === 200) {
          //   ////console.log("epa====",)
          var index;
          let quizes = state.quizes;
          // for (var i = 0; i < quizes.length; i++) {
          //   if (quizes[i].id == id) {
          //     index = i;
          //     break;
          //   }
          // }
          // // //console.log(quizes.length, "::quizes1");
          // // //console.log(index, "::index");
          // quizes.splice(index, 1);
          // // //console.log(quizes.length, "::quizes2");

          // quizes.push(new_quiz);
          // quizes[index] = new_quiz;
          // //console.log(quizes.length, "::quizes2");
          commit("quiz_success", quizes);
          return quizes;
        } else {
          ////console.log("error====");
        }
        return res.status;
      });
    peticiones.push(peticion_quiz);
    const responses = await Promise.all(peticiones);
    ////console.log("responses quiz 649 :::::::::::: ", responses);//, responses[responses.length - 1]
    // if (responses.length > 0 && responses[responses.length - 1].status === 201) {
    //   ////console.log("epa====",)
    //   let quizes = state.quizes;
    //   quizes.push(quiz)
    //   commit('quiz_success', quizes)
    //   return quizes
    // }else{
    //   ////console.log("error====");
    // }
  },
  async deleteQuiz({ commit, state }, id) {
    commit("quiz_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz', 'unlink', [id] ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        ////console.log("res+++++++++++",res);
        if (res.data.result == true) {
          var quizes = state.quizes;
          location.reload();
          commit("quiz_success", quizes);
          return quizes;
        } else {
          commit("quiz_error");
        }
      })
      .catch((err) => {
        commit("quiz_error");
        return err;
      });
  },
  //quiz preview
  async refreshQuizPreview({ commit }, id) {
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        args: [[id], user_context.user_context],
        method: "quiz_preview",
        model: "apache.quiz",
      },
    };

    var response_preview = await this._vm.$http
      .post("/web/dataset/call_button", req_data)
      .then((res) => {
        commit("quiz_preview_success", res.data);
      });
    return;
  },
  async deleteQuizUtility({ commit, state }, id) {
    commit("quiz_request");
    var index;
    var quizes = state.quizes;
    for (var i = 0; i < quizes.length; i++) {
      if (quizes[i].id == id) {
        index = i;
        break;
      }
    }
    quizes.splice(index, 1);
    commit("quiz_success", quizes);
    return quizes;
  },

  // ANCHOR Gallery Methods
  async getIDbyCreateNewGallery({ commit, state }, payload) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context,
        },
        args: [payload], //(Record ID and field to update)
        method: "create",
        model: "apache.quiz.gallery",
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/create", req_data)
      .then(async (res) => {
        if (res.data.result) {
          commit("gallery_create_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },
  async getIDbyUpdateGallery({ commit, state }, payload) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context,
        },
        args: payload, //(Record ID and field to update)
        method: "write",
        model: "apache.quiz.gallery",
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/write", req_data)
      .then(async (res) => {
        if (res.data.result) {
          commit("gallery_update_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },
  async getIDbyCreateNewGalleryPage({ commit, state }, payload) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context,
        },
        args: [payload], //(Record ID and field to update)
        method: "create",
        model: "apache.quiz.gallery.page",
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/create", req_data)
      .then(async (res) => {
        if (res.data.result) {
          commit("gallery_create_page_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },
  async getIDbyUpdateGalleryPage({ commit, state }, payload) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context,
        },
        args: payload, //(Record ID and field to update)
        method: "write",
        model: "apache.quiz.gallery.page",
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/write", req_data)
      .then(async (res) => {
        if (res.data.result) {
          commit("gallery_update_page_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },

  async getGallerysN({ commit, state }, payload) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: {
            ...user_context.user_context,
          },
        },
        args: payload, //(Record ID and field to update)
        method: "read",
        model: "apache.quiz.gallery",
      },
    };
    //console.log("info-", "getGallerysN-action", payload, req_data);

    await this._vm.$http
      .post("/web/dataset/call_kw/read", req_data)
      .then(async (res) => {
        if (res.data.result) {
          commit("get_gallery_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },
  async getGalleryPagesN({ commit, state }, payload) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context,
        },
        args: payload, //(Record ID and field to update)
        method: "read",
        model: "apache.quiz.gallery.page",
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/read", req_data)
      .then(async (res) => {
        if (res.data.result) {
          commit("get_gallery_page_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },

  async deleteGalleryPagesN({ commit, state }, payload) {
    commit("quiz_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        kwargs: {
          context: user_context.user_context,
        },
        args: payload, //(Record ID and field to update)
        method: "unlink",
        model: "apache.quiz.gallery.page",
      },
    };

    await this._vm.$http
      .post("/web/dataset/call_kw/unlink", req_data)
      .then(async (res) => {
        if (res.data.result) {
          commit("delete_gallery_page_success", res.data.result);
        } else {
        }
        return res.data.result;
      });
  },
};

//mutations

export var quizMutations = {
  quiz_request(state) {
    state.status_quiz = "loading";
  },
  quiz_success(state, payload) {
    state.status_quiz = "success";
    state.quizes = payload;
  },
  quiz_singlefield_success(state, payload) {
    state.status_quiz = "success";
    state.singlefield = payload;
  },
  quiz_successbypartner(state, payload) {
    state.status_quiz = "success";
    state.quizbyPartner = payload;
  },
  quiz_stat_success(state, payload) {
    state.status_quiz = "success";
    state.quiz_stat = payload;
  },
  quiz_statg_success(state, payload) {
    state.status_quiz = "success";
    state.quiz_stat_group = payload;
  },
  quiz_create_success(state, payload) {
    state.status_quiz = "success";
    state.id_preview = payload;
  },
  quiz_preview_success(state, payload) {
    ////console.log("aca")
    state.status_quiz = "success";
    state.quiz_preview_response = payload;
  },
  images_success(state, payload) {
    state.status_quiz = "success";
    state.images = payload;
  },
  button_success(state, payload) {
    state.status_quiz = "success";
    state.buttons = payload;
  },
  gallerys_success(state, payload) {
    state.status_quiz = "success";
    state.gallerys = payload;
  },
  buttons_success(state, payload) {
    state.status_button = "success";
    state.buttons = payload;
  },
  quiz_respustasCount_success(state, payload) {
    state.status_quiz = "success";
    state.respustasCount = payload;
  },
  quiz_completadosCount_success(state, payload) {
    state.status_quiz = "success";
    state.completadosCount = payload;
  },
  quiz_paraCompletar_success(state, payload) {
    state.status_quiz = "success";
    state.paraCompletar = payload;
  },
  quiz_commenzadosCount_success(state, payload) {
    state.status_quiz = "success";
    state.commenzadosCount = payload;
  },
  quiz_imagebyQuiz_success(state, payload) {
    state.status_quiz = "success";
    state.imagebyQuiz = payload;
  },
  quiz_graphdatabyQuiz_success(state, payload) {
    state.status_quiz = "success";
    state.graphdatabyQuiz = payload;
  },
  quiz_respustasData_success(state, payload) {
    state.status_quiz = "success";
    state.respustasData = payload;
  },
  quiz_respustasAnswerData_success(state, payload) {
    state.status_quiz = "success";
    //console.log("answerdata payload", payload);
    state.respustasAnswerData = payload;
  },
  quiz_respustasad_success(state, payload) {
    state.status_quiz = "success";
    state.respustasAnswerData = payload;
  },
  // quiz_overview_success(state, payload) {
  //   state.status_quiz = "success";
  //   //console.log("statoverview payload ::: ", payload)
  //   state.statoverview = payload;
  // },
  overview_success(state, payload) {
    state.status_quiz = "success";
    //console.log("statoverview payload ::: ", payload);
    state.overview_stats = payload;
  },
  quiz_question_success(state, payload) {
    state.status_quiz = "success";
    //console.log("question payload ::: ", payload);
    state.questions = payload;
  },
  quiz_ques_success(state, payload) {
    state.status_quiz = "success";
    state.ques_id = payload;
  },
  quiz_option_id_success(state, payload) {
    state.status_quiz = "success";
    //console.log("quiz_option_id_success payload :::: ", payload);
    state.option_id = payload;
  },
  quiz_option_success(state, payload) {
    state.status_quiz = "success";
    ////console.log("options payload ::: ", payload);
    state.question_options = payload;
  },
  quiz_delete_success(state, payload) {
    state.status_quiz = "success";
    //console.log("res_success payload ::: ", payload);
    state.respustasData = payload;
  },
  quiz_option_delete_success(state, payload) {
    state.status_quiz = "success";
    //console.log("res_success payload ::: ", payload);
    // state.respustasData = payload;
  },
  quiz_error(state) {
    state.status_quiz = "error";
  },
  // ANCHOR Gallery mutation
  gallery_create_success(state, payload) {
    state.status_quiz = "success";
    state.s_gallerys = payload;
  },
  gallery_update_success(state, payload) {
    state.status_quiz = "success";
    state.s_gallerys = payload;
  },
  gallery_create_page_success(state, payload) {
    state.status_quiz = "success";
    state.s_gallery_page = payload;
  },
  gallery_update_page_success(state, payload) {
    state.status_quiz = "success";
    state.s_gallery_page = payload;
  },
  get_gallery_success(state, payload) {
    state.status_quiz = "success";
    state.s_getGallerys = payload;
  },
  get_gallery_page_success(state, payload) {
    state.status_quiz = "success";
    state.s_getGalleryPages = payload;
  },

  delete_gallery_page_success(state, payload) {
    state.status_quiz = "success";
    //console.log("info-", "page deleted");
  },
};
